var $7ac5d8283e4613d4$exports = {};
$7ac5d8283e4613d4$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Valt datum \xe4r inte tillg\xe4ngligt.`,
            other: `Valda datum \xe4r inte tillg\xe4ngliga.`
        })}`
};


export {$7ac5d8283e4613d4$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
